// YearFilterDropdown.jsx
import FilterDropdown from "../reuseable/filter-dropdown";

const YearFilterDropdown = ({
  visible,
  onSelect,
  activateOutsideClick,
  style,
}) => {
  const currentYear = new Date().getFullYear();

  // current year se last 5 years
  const options = Array.from({ length: 5 }, (_, i) =>
    String(currentYear - i)
  );

  return (
    <FilterDropdown
      visible={visible}
      options={options}
      onSelect={onSelect}
      activateOutsideClick={activateOutsideClick}
      style={style}
    />
  );
};

export default YearFilterDropdown;
